import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=7b8f792e&scoped=true&"
import script from "./wishlist.vue?vue&type=script&lang=js&"
export * from "./wishlist.vue?vue&type=script&lang=js&"
import style0 from "./wishlist.vue?vue&type=style&index=0&id=7b8f792e&prod&scoped=true&lang=css&"
import style1 from "./wishlist.vue?vue&type=style&index=1&id=7b8f792e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f792e",
  null
  
)

export default component.exports